import { HISTORY_LIST } from '../../stateManagment/gameState';

class HistoryHelperService {
  queue = [];

  addLastHistoryInQueue(historyItem) {
    this.queue.push(historyItem);
  }

  get last() {
    const last = [...this.queue].pop();
    return last || null;
  }

  updateHistory() {
    const last = this.queue.pop();
    if (last) {
      HISTORY_LIST.next(
        [
          last,
          ...HISTORY_LIST.getValue(),
        ],
      );
    }
  }

  get history() {
    return HISTORY_LIST.getValue();
  }
}

export const historyHelperService = new HistoryHelperService();
